// #UbicacionUnify — Taxonomía de objetos del mapa, paridad con OnePlan
// pero en español, adaptada al uso de SOEM (eventos, evaluaciones de
// seguridad). Estructura jerárquica para el sidebar "Add Objects".
//
// Tipos de objeto:
//   - point     → un solo marcador (lat/lng)
//   - polyline  → línea con múltiples vértices (rutas)
//   - polygon   → área cerrada con múltiples vértices
//
// Por ahora SOEM solo soporta `point`. Polylines y polygons quedan
// definidos en el data model para implementación futura — el sidebar
// los muestra como deshabilitados con tooltip "Próximamente".

export const MAP_OBJECT_TREE = [
  {
    id: 'areas_rutas_accesos',
    label: 'Áreas, Rutas y Accesos',
    icon: '🗺️',
    children: [
      {
        id: 'areas',
        label: 'Áreas',
        icon: '⬛',
        type: 'polygon',
        children: [
          { id: 'camping_area',  label: 'Área de acampada',        color: '#15803D', icon: '🏕️' },
          { id: 'crowd_area',    label: 'Zona de público',         color: '#0EA5E9', icon: '👥' },
          { id: 'generic_area',  label: 'Área genérica',           color: '#DC2626', icon: '⬛' },
          { id: 'parking_area',  label: 'Zona de estacionamiento', color: '#F59E0B', icon: '🅿️' },
        ],
      },
      {
        id: 'entry_access_icons',
        label: 'Iconos de entrada y acceso',
        icon: '🚪',
        type: 'point',
        children: [
          { id: 'accessible_parking',  label: 'Estacionamiento accesible', color: '#1A56DB', icon: '♿' },
          { id: 'accessible_ramp',     label: 'Rampa accesible',           color: '#1A56DB', icon: '♿' },
          { id: 'accreditation',       label: 'Acreditación',              color: '#F59E0B', icon: '🪪' },
          { id: 'balloon_arch',        label: 'Arco de globos',            color: '#EC4899', icon: '🎈' },
          { id: 'elevator',            label: 'Elevador',                  color: '#64748B', icon: '🛗' },
          { id: 'entry_gate',          label: 'Puerta de entrada',         color: '#15803D', icon: '🚪' },
          { id: 'evacuation_chair',    label: 'Silla de evacuación',       color: '#F59E0B', icon: '🦽' },
          { id: 'exit_gate',           label: 'Puerta de salida',          color: '#DC2626', icon: '🚪' },
          { id: 'lockers',             label: 'Casilleros',                color: '#F59E0B', icon: '🔒' },
          { id: 'pedestrian_access',   label: 'Acceso peatonal',           color: '#7C3AED', icon: '🚶' },
          { id: 'ticket_check',        label: 'Revisión de boletos',       color: '#1A56DB', icon: '🎫' },
          { id: 'ticket_office',       label: 'Taquilla',                  color: '#F59E0B', icon: '🎫' },
          { id: 'turnstile',           label: 'Torniquete',                color: '#64748B', icon: '🚧' },
          { id: 'vehicle_access',      label: 'Acceso vehicular',          color: '#DC2626', icon: '🚗' },
          { id: 'wristband_collection',label: 'Recolección de pulseras',   color: '#EC4899', icon: '⌚' },
        ],
      },
      {
        id: 'routes',
        label: 'Rutas',
        icon: '〰️',
        type: 'polyline',
        children: [
          { id: 'pedestrian_route', label: 'Ruta peatonal',  color: '#F59E0B', icon: '🚶' },
          { id: 'vehicle_route',    label: 'Ruta vehicular', color: '#EAB308', icon: '🚗' },
        ],
      },
    ],
  },
  {
    id: 'infraestructura',
    label: 'Infraestructura',
    icon: '🏗️',
    children: [
      {
        id: 'audio_visual',
        label: 'Audiovisual',
        icon: '🔊',
        type: 'point',
        children: [
          { id: 'dj_location', label: 'Cabina de DJ',    color: '#7C3AED', icon: '🎧' },
          { id: 'large_screen',label: 'Pantalla gigante', color: '#1A56DB', icon: '📺' },
          { id: 'pa_speakers', label: 'Bocinas / PA',    color: '#0EA5E9', icon: '🔊' },
        ],
      },
      {
        id: 'barriers',
        label: 'Barreras',
        icon: '🚧',
        type: 'polyline',
        children: [
          { id: 'crowd_control_barrier',  label: 'Barrera de control de multitudes', color: '#F59E0B', icon: '🚧' },
          { id: 'front_of_stage_barrier', label: 'Barrera frente de escenario',      color: '#EC4899', icon: '🚧' },
          { id: 'high_perimeter_fence',   label: 'Cerca de perímetro alto',          color: '#EAB308', icon: '🏗️' },
          { id: 'mesh_fence',             label: 'Cerca de malla',                   color: '#64748B', icon: '🪡' },
        ],
      },
      {
        id: 'branding_signage',
        label: 'Branding y señalética',
        icon: '🪧',
        type: 'point',
        children: [
          { id: 'feather_flag',     label: 'Bandera tipo pluma',     color: '#7C3AED', icon: '🚩' },
          { id: 'lamp_post_banner', label: 'Banner de poste',        color: '#1A56DB', icon: '🪧' },
          { id: 'pull_up_banner',   label: 'Roll-up',                color: '#0EA5E9', icon: '🪧' },
          { id: 'sign',             label: 'Letrero',                color: '#64748B', icon: '🪧' },
          { id: 'signage_frame_2',  label: 'Marco de señalética 2 caras', color: '#64748B', icon: '🪧' },
          { id: 'signage_frame_4',  label: 'Marco de señalética 4 caras', color: '#64748B', icon: '🪧' },
          { id: 'stanchion',        label: 'Poste con cinta',        color: '#94A3B8', icon: '🪧' },
        ],
      },
      {
        id: 'broadcast',
        label: 'Transmisión',
        icon: '📹',
        type: 'point',
        children: [
          { id: 'camera_boat',     label: 'Cámara en bote',  color: '#0EA5E9', icon: '📹' },
          { id: 'camera_crane',    label: 'Grúa de cámara',  color: '#7C3AED', icon: '🎥' },
          { id: 'camera_drone',    label: 'Dron',            color: '#1A56DB', icon: '🚁' },
          { id: 'camera_fixed',    label: 'Cámara fija',     color: '#64748B', icon: '📹' },
          { id: 'camera_handheld', label: 'Cámara de mano',  color: '#475569', icon: '📹' },
          { id: 'camera_jimmy',    label: 'Jimmy Jib',       color: '#0F172A', icon: '🎥' },
          { id: 'camera_platform', label: 'Plataforma',      color: '#64748B', icon: '🎥' },
          { id: 'camera_tripod',   label: 'Tripié',          color: '#94A3B8', icon: '📷' },
          { id: 'skycam',          label: 'Skycam',          color: '#1A56DB', icon: '📡' },
        ],
      },
      {
        id: 'electrical',
        label: 'Eléctrico',
        icon: '⚡',
        type: 'point',
        children: [
          { id: 'cable_matting',     label: 'Tapete cubre-cables',        color: '#475569', icon: '🟫' },
          { id: 'computer',          label: 'Computadora',                color: '#1A56DB', icon: '💻' },
          { id: 'distribution_board',label: 'Tablero de distribución',    color: '#F59E0B', icon: '⚡' },
          { id: 'ethernet',          label: 'Ethernet',                   color: '#475569', icon: '🌐' },
          { id: 'ev_charge',         label: 'Carga vehículo eléctrico',   color: '#15803D', icon: '🔌' },
          { id: 'fan',               label: 'Ventilador',                 color: '#64748B', icon: '🌀' },
          { id: 'freezer',           label: 'Congelador',                 color: '#0EA5E9', icon: '🧊' },
          { id: 'fridge',            label: 'Refrigerador',               color: '#0EA5E9', icon: '❄️' },
          { id: 'fuel_cube',         label: 'Tanque de combustible',      color: '#DC2626', icon: '🛢️' },
          { id: 'generator',         label: 'Generador',                  color: '#F59E0B', icon: '⚙️' },
          { id: 'lighting_tower',    label: 'Torre de iluminación',       color: '#EAB308', icon: '💡' },
          { id: 'permanent_power',   label: 'Energía permanente',         color: '#15803D', icon: '🔌' },
          { id: 'printer',           label: 'Impresora',                  color: '#475569', icon: '🖨️' },
          { id: 'radio_tower',       label: 'Torre de radio',             color: '#0EA5E9', icon: '📡' },
          { id: 'street_lamp',       label: 'Farol de calle',             color: '#EAB308', icon: '💡' },
          { id: 'temporary_power',   label: 'Energía temporal',           color: '#F59E0B', icon: '🔌' },
          { id: 'wifi',              label: 'WiFi',                       color: '#1A56DB', icon: '📶' },
        ],
      },
      {
        id: 'food_beverage',
        label: 'Alimentos y bebidas',
        icon: '🍔',
        type: 'point',
        children: [
          { id: 'bar',          label: 'Bar',              color: '#7C3AED', icon: '🍺' },
          { id: 'barbeque',     label: 'Asador / BBQ',     color: '#DC2626', icon: '🍖' },
          { id: 'beer',         label: 'Cerveza',          color: '#F59E0B', icon: '🍺' },
          { id: 'cocktail_bar', label: 'Bar de cocteles',  color: '#EC4899', icon: '🍸' },
          { id: 'fast_food',    label: 'Comida rápida',    color: '#F59E0B', icon: '🍔' },
          { id: 'food_vendor',  label: 'Vendedor de comida',color:'#15803D', icon: '🥘' },
          { id: 'hot_drinks',   label: 'Bebidas calientes',color: '#DC2626', icon: '☕' },
          { id: 'market_stall', label: 'Puesto de mercado',color: '#7C3AED', icon: '🛒' },
          { id: 'wine_bar',     label: 'Bar de vinos',     color: '#7C3AED', icon: '🍷' },
        ],
      },
      {
        id: 'furniture',
        label: 'Mobiliario',
        icon: '🪑',
        type: 'point',
        children: [
          { id: 'chair',         label: 'Silla',             color: '#94A3B8', icon: '🪑' },
          { id: 'folding_chair', label: 'Silla plegable',    color: '#94A3B8', icon: '🪑' },
          { id: 'bench',         label: 'Banca',             color: '#94A3B8', icon: '🪑' },
          { id: 'table',         label: 'Mesa',              color: '#94A3B8', icon: '🟫' },
          { id: 'round_table',   label: 'Mesa redonda',      color: '#94A3B8', icon: '⚪' },
          { id: 'picnic_table',  label: 'Mesa de picnic',    color: '#94A3B8', icon: '🧺' },
          { id: 'beanbag',       label: 'Puff',              color: '#94A3B8', icon: '🛋️' },
        ],
      },
      {
        id: 'points_of_interest',
        label: 'Puntos de interés',
        icon: '📍',
        type: 'point',
        children: [
          { id: 'atm',                 label: 'Cajero automático',         color: '#15803D', icon: '🏧' },
          { id: 'defibrillator',       label: 'Desfibrilador',             color: '#DC2626', icon: '⚡' },
          { id: 'event_control',       label: 'Control del evento',        color: '#1A56DB', icon: '🎯' },
          { id: 'first_aid',           label: 'Primeros auxilios',         color: '#DC2626', icon: '🩹' },
          { id: 'hospital',            label: 'Hospital',                  color: '#DC2626', icon: '🏥' },
          { id: 'information_point',   label: 'Punto de información',      color: '#0EA5E9', icon: 'ℹ️' },
          { id: 'lost_property',       label: 'Objetos perdidos',          color: '#F59E0B', icon: '🎒' },
          { id: 'merchandise',         label: 'Mercadería',                color: '#7C3AED', icon: '🛍️' },
          { id: 'missing_persons',     label: 'Personas perdidas',         color: '#DC2626', icon: '🚨' },
          { id: 'photo_point',         label: 'Punto fotográfico',         color: '#EC4899', icon: '📸' },
          { id: 'podium',              label: 'Podio',                     color: '#F59E0B', icon: '🏆' },
          { id: 'stage',               label: 'Escenario',                 color: '#EC4899', icon: '🎭' },
          { id: 'vip',                 label: 'VIP',                       color: '#F59E0B', icon: '⭐' },
          { id: 'welfare_point',       label: 'Punto de bienestar',        color: '#15803D', icon: '💚' },
        ],
      },
      {
        id: 'safety_security',
        label: 'Seguridad',
        icon: '🛡️',
        type: 'point',
        children: [
          { id: 'cctv_camera',          label: 'Cámara CCTV',             color: '#0F172A', icon: '📹' },
          { id: 'cctv_360',             label: 'Cámara 360°',             color: '#0F172A', icon: '📹' },
          { id: 'bollard',              label: 'Bolardo',                 color: '#64748B', icon: '🚧' },
          { id: 'emergency_access',     label: 'Acceso de emergencia',    color: '#DC2626', icon: '🚨' },
          { id: 'emergency_exit',       label: 'Salida de emergencia',    color: '#DC2626', icon: '🚪' },
          { id: 'evacuation_meeting',   label: 'Punto de reunión',        color: '#15803D', icon: '📍' },
          { id: 'fire_extinguisher',    label: 'Extintor',                color: '#DC2626', icon: '🧯' },
          { id: 'fire_hydrant',         label: 'Hidrante',                color: '#DC2626', icon: '🚒' },
          { id: 'risk_assessment',      label: 'Punto de riesgo',         color: '#F59E0B', icon: '⚠️' },
          { id: 'security_checkpoint',  label: 'Punto de control',        color: '#1A56DB', icon: '🛡️' },
        ],
      },
      {
        id: 'structures',
        label: 'Estructuras',
        icon: '🏗️',
        type: 'point',
        children: [
          { id: 'ada_viewing',     label: 'Plataforma accesible',  color: '#1A56DB', icon: '♿' },
          { id: 'bike_rack',       label: 'Estacionamiento bicis', color: '#15803D', icon: '🚲' },
          { id: 'canopy_tent',     label: 'Carpa con dosel',       color: '#F59E0B', icon: '⛺' },
          { id: 'gantry',          label: 'Pórtico',               color: '#64748B', icon: '🏗️' },
          { id: 'inflatable_arch', label: 'Arco inflable',         color: '#EC4899', icon: '🎈' },
          { id: 'office_trailer',  label: 'Tráiler de oficina',    color: '#475569', icon: '🚐' },
          { id: 'pedestrian_bridge',label:'Puente peatonal',       color: '#1A56DB', icon: '🌉' },
          { id: 'ramp',            label: 'Rampa',                 color: '#1A56DB', icon: '📐' },
          { id: 'scaffold_tower',  label: 'Torre de andamios',     color: '#F59E0B', icon: '🏗️' },
          { id: 'shipping_container',label:'Contenedor',           color: '#475569', icon: '📦' },
          { id: 'stage',           label: 'Escenario',             color: '#EC4899', icon: '🎭' },
          { id: 'stairs',          label: 'Escaleras',             color: '#64748B', icon: '🪜' },
          { id: 'tent',            label: 'Carpa',                 color: '#F59E0B', icon: '⛺' },
        ],
      },
      {
        id: 'toilets',
        label: 'Sanitarios',
        icon: '🚻',
        type: 'point',
        children: [
          { id: 'accessible_toilet',  label: 'Sanitario accesible',  color: '#1A56DB', icon: '♿' },
          { id: 'baby_change',        label: 'Cambiador de bebé',    color: '#EC4899', icon: '🍼' },
          { id: 'mens_urinal',        label: 'Mingitorio',           color: '#1A56DB', icon: '🚹' },
          { id: 'portable_restroom',  label: 'Baño portátil',        color: '#15803D', icon: '🚻' },
          { id: 'restroom_trailer',   label: 'Tráiler de baños',     color: '#15803D', icon: '🚻' },
          { id: 'toilets_permanent',  label: 'Sanitarios permanentes',color:'#475569', icon: '🚻' },
          { id: 'toilets_temporary',  label: 'Sanitarios temporales',color: '#F59E0B', icon: '🚻' },
        ],
      },
      {
        id: 'traffic_management',
        label: 'Manejo de tráfico',
        icon: '🚦',
        type: 'point',
        children: [
          { id: 'cone',                label: 'Cono',               color: '#F59E0B', icon: '🚧' },
          { id: 'crossing_point',      label: 'Punto de cruce',     color: '#EAB308', icon: '🚸' },
          { id: 'danger',              label: 'Peligro',            color: '#DC2626', icon: '⚠️' },
          { id: 'detour',              label: 'Desvío',             color: '#F59E0B', icon: '↪️' },
          { id: 'no_entry',            label: 'No pasar',           color: '#DC2626', icon: '⛔' },
          { id: 'no_parking',          label: 'No estacionar',      color: '#DC2626', icon: '🚫' },
          { id: 'road_closed',         label: 'Camino cerrado',     color: '#DC2626', icon: '🚧' },
          { id: 'roadworks',           label: 'Obras viales',       color: '#F59E0B', icon: '🚧' },
          { id: 'stop',                label: 'Alto',               color: '#DC2626', icon: '🛑' },
          { id: 'traffic_lights',      label: 'Semáforo',           color: '#EAB308', icon: '🚦' },
          { id: 'turn_left',           label: 'Vuelta izquierda',   color: '#1A56DB', icon: '⬅️' },
          { id: 'turn_right',          label: 'Vuelta derecha',     color: '#1A56DB', icon: '➡️' },
        ],
      },
      {
        id: 'transport',
        label: 'Transporte',
        icon: '🚌',
        type: 'point',
        children: [
          { id: 'airport',            label: 'Aeropuerto',         color: '#1A56DB', icon: '✈️' },
          { id: 'boat',               label: 'Bote',               color: '#0EA5E9', icon: '⛵' },
          { id: 'bus_stop',           label: 'Parada de autobús',  color: '#F59E0B', icon: '🚏' },
          { id: 'bus_station',        label: 'Estación de buses',  color: '#F59E0B', icon: '🚌' },
          { id: 'cycle_parking',      label: 'Estacionamiento bicis',color:'#15803D', icon: '🚲' },
          { id: 'helipad',            label: 'Helipuerto',         color: '#DC2626', icon: '🚁' },
          { id: 'load_zone',          label: 'Zona de carga',      color: '#F59E0B', icon: '📦' },
          { id: 'parking',            label: 'Estacionamiento',    color: '#1A56DB', icon: '🅿️' },
          { id: 'taxi',               label: 'Taxi',               color: '#EAB308', icon: '🚕' },
          { id: 'train_station',      label: 'Estación de tren',   color: '#1A56DB', icon: '🚉' },
          { id: 'transport_desk',     label: 'Mostrador transporte',color:'#1A56DB', icon: 'ℹ️' },
        ],
      },
      {
        id: 'vehicles',
        label: 'Vehículos',
        icon: '🚗',
        type: 'point',
        children: [
          { id: 'ambulance',           label: 'Ambulancia',        color: '#DC2626', icon: '🚑' },
          { id: 'car',                 label: 'Auto',              color: '#1A56DB', icon: '🚗' },
          { id: 'cargo_van',           label: 'Camioneta de carga',color: '#64748B', icon: '🚐' },
          { id: 'city_bus',            label: 'Autobús urbano',    color: '#F59E0B', icon: '🚌' },
          { id: 'coach',               label: 'Autobús turístico', color: '#7C3AED', icon: '🚍' },
          { id: 'fire_truck',          label: 'Camión de bomberos',color: '#DC2626', icon: '🚒' },
          { id: 'food_trailer',        label: 'Tráiler de comida', color: '#F59E0B', icon: '🚚' },
          { id: 'forklift',            label: 'Montacargas',       color: '#EAB308', icon: '🚛' },
          { id: 'golf_cart',           label: 'Carro de golf',     color: '#15803D', icon: '🛺' },
          { id: 'motorcycle',          label: 'Motocicleta',       color: '#0F172A', icon: '🏍️' },
          { id: 'pickup_truck',        label: 'Pickup',            color: '#475569', icon: '🛻' },
          { id: 'police_patrol',       label: 'Patrulla',          color: '#1A56DB', icon: '🚓' },
          { id: 'satellite_van',       label: 'Camioneta satélite',color: '#0F172A', icon: '🛰️' },
        ],
      },
      {
        id: 'waste',
        label: 'Residuos',
        icon: '🗑️',
        type: 'point',
        children: [
          { id: 'dumpster',     label: 'Contenedor de basura',     color: '#64748B', icon: '🗑️' },
          { id: 'trash',        label: 'Basura',                   color: '#475569', icon: '🗑️' },
          { id: 'recycling',    label: 'Residuos y reciclaje',     color: '#15803D', icon: '♻️' },
        ],
      },
      {
        id: 'water_sanitation',
        label: 'Agua y saneamiento',
        icon: '💧',
        type: 'point',
        children: [
          { id: 'drinks_station',     label: 'Estación de bebidas',    color: '#0EA5E9', icon: '🥤' },
          { id: 'fire_hydrant_w',     label: 'Hidrante',               color: '#DC2626', icon: '🚒' },
          { id: 'hand_wash',          label: 'Lavado de manos',        color: '#0EA5E9', icon: '🧼' },
          { id: 'shower',             label: 'Regadera',               color: '#0EA5E9', icon: '🚿' },
          { id: 'sink',               label: 'Lavabo',                 color: '#0EA5E9', icon: '🚰' },
          { id: 'water_connection',   label: 'Conexión de agua',       color: '#0EA5E9', icon: '🚰' },
          { id: 'water_fountain',     label: 'Bebedero',               color: '#0EA5E9', icon: '⛲' },
          { id: 'water_refill',       label: 'Punto de recarga de agua',color:'#0EA5E9', icon: '💧' },
        ],
      },
    ],
  },
  {
    id: 'personal',
    label: 'Personal',
    icon: '👥',
    type: 'point',
    children: [
      { id: 'custom_dot',  label: 'Punto personalizado', color: '#475569', icon: '⚫' },
      { id: 'fire',        label: 'Bomberos',            color: '#F97316', icon: '🚒' },
      { id: 'manager',     label: 'Gerente',             color: '#6B7280', icon: '👔' },
      { id: 'medical',     label: 'Médico',              color: '#DC2626', icon: '🩺' },
      { id: 'police',      label: 'Policía',             color: '#1E40AF', icon: '👮' },
      { id: 'security',    label: 'Seguridad',           color: '#0EA5E9', icon: '🛡️' },
      { id: 'steward',     label: 'Acomodador',          color: '#15803D', icon: '🧍' },
      { id: 'supervisor',  label: 'Supervisor',          color: '#7C3AED', icon: '👁️' },
      { id: 'volunteer',   label: 'Voluntario',          color: '#EC4899', icon: '🤝' },
    ],
  },
];

// Flatten: { item_id: { ...item, parentLabel } }
export const MAP_OBJECT_FLAT = (() => {
  const flat = {};
  const walk = (nodes, parentLabel = '', defaultType = 'point') => {
    for (const node of nodes) {
      if (node.children) {
        walk(node.children, node.label, node.type || defaultType);
      } else {
        flat[node.id] = { ...node, type: defaultType, parentLabel };
      }
    }
  };
  walk(MAP_OBJECT_TREE);
  return flat;
})();

export function getMapObjectById(id) {
  return MAP_OBJECT_FLAT[id] || null;
}
